module.exports = __webpack_public_path__ + "static/media/project-6.0586d65a.jpg";